export enum ModalState {
  SUBMIT_ACTIVITY,
  SUBMIT_ACTIVITY_MULTIPLE_VVBS,
  DIGITALLY_SUBMIT_ACTIVITY,
  MANUALLY_SUBMIT_ACTIVITY,
}
